module.exports = __webpack_public_path__ + "static/media/pdf.2cf62b84.svg";